import { ScenarioModel, SituationModel } from "../../clients/KompasApi";

const isSharedPropertyKey = <TA extends object, TB extends object>(
  key: keyof TA,
  situation: TB
): key is keyof (TA | TB) => key in situation;

export const extractValue = (value: unknown) => {
  if (typeof value === "object" && value) {
    if ("name" in value) {
      return value.name;
    }
    return null;
  }

  return value;
};

export const hasMeasure = (
  measure: keyof ScenarioModel,
  scenarios: ScenarioModel[],
  situation: SituationModel,
  onlyDifferences: boolean
) => {
  if (scenarios.some((s) => Boolean(s[measure]))) {
    if (isSharedPropertyKey<ScenarioModel, SituationModel>(measure, situation)) {
      return (
        !onlyDifferences ||
        scenarios.some(
          (s) => extractValue(s[measure]) !== extractValue(situation[measure])
        )
      );
    }
    return true;
  }
  return false;
};

export const hasAnyMeasure = (
  measures: (keyof ScenarioModel)[],
  scenarios: ScenarioModel[],
  situation: SituationModel,
  onlyDifferences: boolean
) =>
  measures.some((measure) =>
    hasMeasure(measure, scenarios, situation, onlyDifferences)
  );
